import React from 'react'
import { AdminLayout } from '../AdminLayout/AdminLayout'

export const Dashboard = () => {
    return (
        <AdminLayout>
            <div className='p-4 text-secondary'>
                <h3>Dashboard</h3>
            </div>
        </AdminLayout>
    )
}
